// extracted by mini-css-extract-plugin
export default {"box":"miTranslator_box__oGgy8","warp":"miTranslator_warp__d1FBK","foot":"miTranslator_foot__X78lK","home_title":"miTranslator_home_title__YXxF8","table":"miTranslator_table__0OfKk"};